import { safetyTips } from "@/mocks/home";

export default function Safety() {
  return (
    <section id="safety" className="anchor-offset bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">安全交友指南</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            有温度的相遇，也需要有分寸的保护
          </h2>
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            无论聊得多投缘，安全感都应该由自己把握。下面几条建议适用于所有线上交友场景，建议在首次见面之前再看一遍。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {safetyTips.map((tip) => (
            <article key={tip.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${tip.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div className="flex flex-col gap-1">
                <h3 className="font-heading text-base text-foreground-950">{tip.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}